import initialState from './initialState'
import {
  ProjectsLoadingAction,
  GetProjectsAction,
  AddProjectAction,
  UpdateProjectAction,
  PROJECTS_LOADING,
  RECEIVE_PROJECTS,
  CREATE_PROJECT,
  EDIT_PROJECT,
  SAVE_PROCORE_PROJECTS,
  SaveProcoreProjectsAction,
  PROCORE_LOADING,
  IMPORT_PROCORE_PROJECTS,
  ProcoreLoadingAction,
  ImportProcoreProjectsAction
} from './actions'
import { Project } from 'Projects/Types/types'

const reducer = (
  state = initialState,
  action:
    | ProjectsLoadingAction
    | GetProjectsAction
    | AddProjectAction
    | UpdateProjectAction
    | SaveProcoreProjectsAction
    | ProcoreLoadingAction
    | ImportProcoreProjectsAction
) => {
  switch (action.type) {
    case PROJECTS_LOADING:
      return Object.assign({}, state, {
        loading: action.loading
      })
    case RECEIVE_PROJECTS:
      return Object.assign({}, state, {
        projectList: action.payload.data,
        loading: action.loading
      })
    case CREATE_PROJECT:
      const newProjectList = [...state.projectList, { ...action.payload.data }].sort((a, b) => {
        return a.projectName.localeCompare(b.projectName, 'en', { sensitivity: 'base' })
      })
      return Object.assign({}, state, {
        projectList: newProjectList,
        loading: action.loading
      })
    case EDIT_PROJECT:
      const updatedProjectIndex = state.projectList.findIndex(
        (project: Project) => project._id === action.payload.data._id
      )
      return Object.assign({}, state, {
        projectList: [
          ...state.projectList.slice(0, updatedProjectIndex),
          { ...action.payload.data },
          ...state.projectList.slice(updatedProjectIndex + 1)
        ],
        loading: action.loading
      })
    case PROCORE_LOADING:
      return Object.assign({}, state, {
        procoreLoading: action.procoreLoading
      })
    case IMPORT_PROCORE_PROJECTS:
      return Object.assign({}, state, {
        procoreProjects: action.payload.data,
        procoreLoading: action.procoreLoading
      })
    case SAVE_PROCORE_PROJECTS:
      return Object.assign({}, state, {
        projectList: [...state.projectList, ...action.payload.data],
        procoreLoading: action.procoreLoading
      })
    default:
      return state
  }
}

export default reducer
